import { useEffect } from 'react';

export function useDocumentTitle(title: string) {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · LD Gestão` : 'LD Gestão';
    return () => {
      document.title = previous;
    };
  }, [title]);
}
